module.exports = __webpack_public_path__ + "img/ring_y_c_null_null@3x.e7c6b0ad.png";